import React, {useEffect, useState} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {createElementFromHTML} from "../../utils/utilsHelpers";
import ModalClose from "./ModalClose";

export default function ResponseModal(props) {

    let {
        modalSize,
        bgColor,
        textColor,
        btnColor='',
        icon,
        showIcon=true,
        header='',
        message='',
        centered=true,
        textAlignment='center',
        btnClose=true,
        showBackdrop=true,
        dialogClasses='',
        borderColor=null,
        autoClose=false,
        bsPrefix=null,
        JSXContent=false,
        show } = props;
    // also in props: props.handleShow

    const borderClasses = borderColor ? `border border-${borderColor}` : '';
    const activeBackgroundStyles = showBackdrop ? {} : { top: 'unset', left: 'unset', width: 'auto', right: 'auto'}
    const content = JSXContent ? message : createElementFromHTML(message);

    useEffect(() => {
        if(show && !showBackdrop) {
            document.body.style.overflow = 'auto';
        }
        if(show && autoClose) {
            setTimeout(() => { props.handleShow(false) }, 3000);
        }
    })

    return (
        <Modal
            show={show}
            bsPrefix={bsPrefix}
            centered={centered}
            size={modalSize}
            contentClassName={`modal-filled bg-${bgColor} text-${textColor} ${borderClasses}`}
            backdrop={showBackdrop}
            dialogClassName={dialogClasses}
            style={activeBackgroundStyles}>

            {!btnClose && <ModalClose onClose={props.handleShow} color={btnColor} />}
            <Modal.Body className={`p-3 text-${textAlignment}`}>
                {showIcon && <i className={`fal fa-${icon} my-1 fs-1`}></i>}
                {header && <h4 className={`text-${textColor} mt-2`}>{header}</h4>}
                <div className={`${header && 'mt-3'} content-styling`}>{content}</div>
                {btnClose && <Button variant={btnColor} className={'my-3'} onClick={() => props.handleShow(false)}>
                    Close
                </Button>}
            </Modal.Body>
        </Modal>
    )
}